const initialState = {
  counter: 10,
  personalInfo: {
    name: "",
    iAm: "",
    aboutMe: "",
    height: "4.5",
    weight: "",
    profileImage: "",
    editedUrl: "",
    bloodGroup: "",
    complextion: "",
    maritalStatus: "",
    hobbies: "",
    aboutMyFamily: "",
    bodyType: "",
    eyeWear: "",
  },
  birthDetails: {
    dob: {
      date: "",
      placeOfBirth: "",
      age: "",
      time: "",
      day: "",
    },
    tamilYear: "",
    tamilMonth: "",
    tamilDate: "",
  },
  residentialAddress: {
    address: "",
    landmark: "",
    hometown: "",
    city: "",
    stateName: "",
    nationality: "",
    pincode: "",
  },
  qualification: [
    {
      fieldOfStudy: "",
      degree: "",
      currentlyPursuing: false,
    },
  ],
  occupation: {
    companyName: "",
    designation: "",
    annualIncome: "",
    cityOfWorking: "",
  },
  horoscopeDetails: {
    rasi: "",
    nakshatra: "",
    padham: "",
    gothram: "",
    mathulam: "",
    suthaJadhagam: "",
    lagnam: "",
    naaligai: "",
    thithi: "",
    dasaPlanet: "",
    dasaBalance: "",
    god: "",
    skipDosham: true,
    raguDosham: "",
    chevaiDosham: "",
    kalathiraDosham: "",
    mangalyaDosham: "",
    pithruDosham: "",
    suryaDosham: "",
    horoscopeHints: "",
  },
  familyDetails: {
    fatherName: "",
    fatherOccupation: "",
    fatherEducation: "",
    fatherAlive: "",
    motherName: "",
    motherOccupation: "",
    motherEducation: "",
    motherAlive: "",
    religion: "",
    caste: "",
    familyStatus: "",
    siblings: {
      brother: {
        number: "",
        marriageNum: "",
      },
      sister: {
        number: "",
        marriageNum: "",
      },
    },
  },
  horoscopeImage: "",
  editedHoroscopeImage: "",
  govtId: "",
  editedGovtId: "",
  lookingFor: "",
  createdBy: "",
  startDate: "",
  contactDetails: {
    emailId: "",
    contactNumber: "",
    whatsappNumber: "",
    alternativeContactNumber: "",
  },
  rasiKatam: [[], [], [], [], [], [], [], [], [], [], [], []],
  rasiPlanets: {
    Ma: "Select",
    Ve: "Select",
    Me: "Select",
    Su: "Select",
    Ka: "Select",
    Ju: "Select",
    Mo: "Select",
    Sa: "Select",
    Ke: "Select",
    La: "Select",
    Ra: "Select",
  },
  navamsaKatam: [[], [], [], [], [], [], [], [], [], [], [], []],
  navamsaPlanets: {
    Ma: "Select",
    Ve: "Select",
    Me: "Select",
    Su: "Select",
    Ka: "Select",
    Ju: "Select",
    Mo: "Select",
    Sa: "Select",
    Ke: "Select",
    La: "Select",
    Ra: "Select",
  },
  ownHouse: "Yes",
  verificationDetails: {
    emailVerificationDetails: {
      status: "",
      message: "",
    },
    mobileVerificationDetails: {
      status: "",
      message: "",
    },
    govtIdVerificationDetails: {
      status: "",
      message: "",
    },
  },
  eatingHabits: "",
  drinkingHabits: "",
  smokingHabits: "",
  propertyDetails: "",
  otherIncome: "",
  // profileStatus: "",
  skipRasi: false,
  skipNavamsa: false,
  isProfileFetched: false,
  isFormChanged: false,
};

export default initialState;
